import { render, staticRenderFns } from "./businessonebox-allinboxsystem.vue?vue&type=template&id=ec8641ea&"
import script from "./businessonebox-allinboxsystem.vue?vue&type=script&lang=js&"
export * from "./businessonebox-allinboxsystem.vue?vue&type=script&lang=js&"
import style0 from "./businessonebox-allinboxsystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports